import axios from 'axios';

// Change this to whatever you already have:
export const API_BASE_URL =
    process.env.NODE_ENV === 'production'
        ? 'https://api.simpledoc.opus-software.com.br'
        : 'http://localhost:8005';

let onUnauthenticated = () => {};   // will be replaced later

export const setOnUnauthenticated = cb => { onUnauthenticated = cb; };

const http = axios.create({
    baseURL: API_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
});

/* 1. Inject the token before every request */
http.interceptors.request.use(cfg => {
    const raw = localStorage.getItem('user');
    if (raw) {
        const { token } = JSON.parse(raw);
        if (token) cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

/* 2. Central “401” handling */
http.interceptors.response.use(
    res => res,
    err => {
        console.log( "Oops, err:: ", err);
        if (err.response?.status === 401) {
            onUnauthenticated();      // ⇢ will call logout() later
        }
        return Promise.reject(err.response?.data ?? err);  // propagate only the payload
    },
);

export default http;

// export const doLogin = async (username, password) => {
//     try {
//         const response = await axios.post(`${API_BASE_URL}/api/v1/token`, {
//             email_or_username: username,
//             password: password,
//         }, {
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//         });
//         const data = response.data;
//         localStorage.setItem('jwt_token', data.access_token);
//         return data.access_token;
//     } catch (error) {
//         console.error('Login failed:', error);
//         throw new Error('Login failed');
//     }
// };
//
